import { render, staticRenderFns } from "./PdfCore.vue?vue&type=template&id=6d4a1e0e&"
import script from "./PdfCore.vue?vue&type=script&lang=js&"
export * from "./PdfCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports